var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "new_top" },
        [_c("header2"), _vm._v(" "), _c("navigation")],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "new_content" }, [
        _c("div", { staticClass: "new_jpkc_erji" }, [
          _c(
            "div",
            { staticClass: "new_webposition" },
            [
              _c(
                "el-breadcrumb",
                { staticClass: "nje_last", attrs: { separator: "/" } },
                [
                  _c("el-breadcrumb-item", { staticStyle: { float: "none" } }, [
                    _vm._v("资讯列表")
                  ]),
                  _vm._v(" "),
                  _c("el-breadcrumb-item", { staticStyle: { float: "none" } }, [
                    _vm._v(_vm._s(_vm.consultName))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "new_jpkc_list", attrs: { id: "kc" } },
            _vm._l(_vm.newsList, function(item) {
              return _c(
                "div",
                { staticClass: "njl1" },
                [
                  _c(
                    "div",
                    { staticClass: "njl_pic" },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: { path: "newsInfo", query: { id: item.id } },
                            target: "_blank"
                          }
                        },
                        [_c("img", { attrs: { src: item.image } })]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      staticClass: "njl_text",
                      attrs: {
                        to: { path: "newsInfo", query: { id: item.id } },
                        target: "_blank"
                      }
                    },
                    [
                      _c("span", { staticClass: "njl_title textover" }, [
                        _vm._v(_vm._s(item.newsTitle))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "njl_intro" }, [
                        _vm._v(_vm._s(item.description))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "njl_speaker" }, [
                        _vm._v(_vm._s(item.publishTime))
                      ])
                    ]
                  )
                ],
                1
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "new_num_list", attrs: { id: "coursePageUl" } },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.pageNum,
                  "page-size": _vm.pageSize,
                  layout: "prev, pager, next, jumper",
                  total: _vm.total
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                  "update:currentPage": function($event) {
                    _vm.pageNum = $event
                  },
                  "update:current-page": function($event) {
                    _vm.pageNum = $event
                  }
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("footer1")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60318702", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60318702","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/NewsMore.vue
// module id = null
// module chunks = 